
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { QueryPropertyModel } from './Models.QueryProperty';
import { Model, ModelProperty } from 'models/Model';


export class ExpressionFilterModel extends Model<ExpressionFilterModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'property', type: 'QueryPropertyModel', languageString: 'expressionFilter.property.property', isHidden: true, isObject: true, new: () => { return new QueryPropertyModel }, properties: () => { return QueryPropertyModel.classProperties } },
		{ name: 'value', type: 'any', languageString: 'expressionFilter.property.value' },
		{ name: 'operator', type: 'Comparison', languageString: 'expressionFilter.property.operator' }
	];
	[key: string]: any;
	
	public property?: QueryPropertyModel;
	public value?: any;
	public operator: Comparison;
    
	constructor(){
		super();
		this.property = undefined;
		this.value = undefined;
		this.operator = 0;
		
	}
	getProperties(){
		return ExpressionFilterModel.classProperties;
	}
}

export enum Comparison{
	Equal = 0,
	LessThan = 1,
	LessThanOrEqual = 2,
	GreaterThan = 3,
	GreaterThanOrEqual = 4,
	NotEqual = 5,
	Contains = 6,
	StartsWith = 7,
	EndsWith = 8,
	NotNull = 9,
	Null = 10,
	In = 11,
	NotIn = 12
}
export namespace Comparison {
	export function getKeys(): Map<Comparison, string> {
		return new Map([[0, 'Equal'], [1, 'LessThan'], [2, 'LessThanOrEqual'], [3, 'GreaterThan'], [4, 'GreaterThanOrEqual'], [5, 'NotEqual'], [6, 'Contains'], [7, 'StartsWith'], [8, 'EndsWith'], [9, 'NotNull'], [10, 'Null'], [11, 'In'], [12, 'NotIn']]);
	}
}
